import React from 'react';
import { Input, DatePicker } from 'antd';
import dayjs from 'dayjs';
import { T206FormData } from '../hooks/useT206Record';

const { TextArea } = Input;

interface Props {
  formData: T206FormData;
  isEditing: boolean;
  setField: <K extends keyof T206FormData>(field: K, value: T206FormData[K]) => void;
}

const Tab1MeetingInfo: React.FC<Props> = ({ formData, isEditing, setField }) => {
  return (
    <div className="t206-form-grid">
      <div className="t206-form-row">
        <label className="t206-label required">會議主題</label>
        <Input
          value={formData.ft160_11}
          disabled={!isEditing}
          maxLength={48}
          onChange={e => setField('ft160_11', e.target.value)}
          className="t206-input"
        />
      </div>

      <div className="t206-form-row">
        <label className="t206-label">會議日期</label>
        <DatePicker
          value={formData.ft160_13 ? dayjs(formData.ft160_13) : null}
          disabled={!isEditing}
          onChange={d => setField('ft160_13', d ? d.format('YYYY-MM-DD') : '')}
          style={{ width: '100%' }}
        />
      </div>

      <div className="t206-form-row">
        <label className="t206-label">開始時間</label>
        <Input
          value={formData.ft160_14}
          disabled={!isEditing}
          maxLength={8}
          placeholder="HH:MM:SS"
          onChange={e => setField('ft160_14', e.target.value)}
          className="t206-input"
        />
      </div>

      <div className="t206-form-row">
        <label className="t206-label">結束時間</label>
        <Input
          value={formData.ft160_15}
          disabled={!isEditing}
          maxLength={8}
          placeholder="HH:MM:SS"
          onChange={e => setField('ft160_15', e.target.value)}
          className="t206-input"
        />
      </div>

      <div className="t206-form-row">
        <label className="t206-label">會議地點</label>
        <Input
          value={formData.ft160_16}
          disabled={!isEditing}
          maxLength={40}
          onChange={e => setField('ft160_16', e.target.value)}
          className="t206-input"
        />
      </div>

      <div className="t206-form-row">
        <label className="t206-label">我司人數</label>
        <Input
          value={formData.ft160_18 !== undefined ? String(formData.ft160_18) : '0'}
          disabled
          className="t206-input"
        />
      </div>

      <div className="t206-form-row">
        <label className="t206-label">議題數</label>
        <Input
          value={formData.ft160_19 !== undefined ? String(formData.ft160_19) : '0'}
          disabled
          className="t206-input"
        />
      </div>

      <div className="t206-form-row">
        <label className="t206-label">客戶人數</label>
        <Input
          value={formData.ft160_25 !== undefined ? String(formData.ft160_25) : '0'}
          disabled
          className="t206-input"
        />
      </div>

      <div className="t206-form-row">
        <label className="t206-label required">記錄人代碼</label>
        <Input
          value={formData.ft160_22}
          disabled={!isEditing}
          maxLength={8}
          onChange={e => setField('ft160_22', e.target.value)}
          className="t206-input"
        />
      </div>

      <div className="t206-form-row t206-form-row-full">
        <label className="t206-label">說明</label>
        <TextArea
          value={formData.ft160_12}
          disabled={!isEditing}
          rows={3}
          onChange={e => setField('ft160_12', e.target.value)}
          className="t206-input"
        />
      </div>
    </div>
  );
};

export default Tab1MeetingInfo;
